import { SortBy } from '@common/enums';
import { ColorModel } from '@common/models';
import { ColorFilters } from '@core/components/filters/filterUtils';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ColorState {
    selectedColor?: ColorModel;
    prevSelectedColor?: ColorModel;
    sortBy: SortBy;
    colorFilters?: ColorFilters;
    restorableColor?: ColorModel;
}

const initialState: ColorState = {
    selectedColor: undefined,
    prevSelectedColor: undefined,
    sortBy: SortBy.None,
    colorFilters: undefined,
    restorableColor: undefined,
};

const colorSlice = createSlice({
    name: 'color',
    initialState,
    reducers: {
        updateSelectedColor: (state, action: PayloadAction<ColorModel>) => {
            state.selectedColor = action.payload;
        },
        resetSelectedColor: (state) => {
            state.selectedColor = undefined;
        },
        updatePrevSelectedColor: (state, action: PayloadAction<ColorModel | undefined>) => {
            state.prevSelectedColor = action.payload;
        },
        updateColorSortBy: (state, action: PayloadAction<SortBy>) => {
            state.sortBy = action.payload;
        },
        updateColorFilters: (state, action: PayloadAction<ColorFilters>) => {
            state.colorFilters = action.payload;
        },
        resetColorFilters: (state) => {
            state.colorFilters = initialState.colorFilters;
        },
        updateRestorableColor: (state, action: PayloadAction<ColorModel | undefined>) => {
            state.restorableColor = action.payload;
        },
    },
});

export const {
    updateSelectedColor,
    resetSelectedColor,
    updateColorSortBy,
    updateColorFilters,
    resetColorFilters,
    updateRestorableColor,
    updatePrevSelectedColor,
} = colorSlice.actions;

export const selectSelectedColor = ({ color }: RootState): ColorModel | undefined => color.selectedColor;
export const selectPrevSelectedColor = ({ color }: RootState): ColorModel | undefined => color.prevSelectedColor;

export const selectColorSortBy = ({ color }: RootState): SortBy => color.sortBy;

export const selectColorFilters = ({ color }: RootState): ColorFilters | undefined => color.colorFilters;

export const selectRestorableColor = ({ color }: RootState): ColorModel | undefined => color.restorableColor;

export default colorSlice.reducer;
